import type { WidgetEventName, WidgetSource } from './types';
import { contactCaptureActionUrl } from './endpoints';

type CaptureAnalyticsEvent = 'viewed' | 'opened' | 'dismissed';

/** Analytics must never block rendering, dismissal, or contact submission. */
export const trackCaptureEvent = async (source: WidgetSource, type: CaptureAnalyticsEvent) => {
  if (source.host.hasAttribute('data-bhi-preview')) return;

  try {
    const url = contactCaptureActionUrl(source.configUrl, 'event');
    if (!url) return;
    url.searchParams.set('type', type);
    await fetch(url.toString(), {
      method: 'POST',
      credentials: 'omit',
      keepalive: true,
    });
  } catch {
    // Best effort: network failures must not affect the visitor's form.
  }
};

export const emitWidgetEvent = (
  name: WidgetEventName,
  captureId: string,
  detail: Record<string, unknown> = {},
) => {
  window.dispatchEvent(new CustomEvent(name, {
    detail: { captureId, ...detail },
  }));
};
